import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import CreateOrganizationForm from "./CreateOrganizationForm";

interface Props {
  rejectionReason?: string;
  onResubmit: () => void;
  code?: string;
  name?: string;
  logoUrl?: string;
  websiteUrl?: string;
  description?: string;
}

const OrganizationRejected: React.FC<Props> = ({
  rejectionReason,
  onResubmit,
  code,
  name,
  logoUrl,
  websiteUrl,
  description,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.rejectedBox}>
        <div className={styles.statusIcon}>
          <img
            src="/assets/images/svg/errorStatus.svg"
            alt=""
            width={40}
            height={40}
          />
        </div>
        <div className={styles.title}>{t("lbl_org_rejected_title")}</div>
        <div className={styles.subtitle}>
          {rejectionReason || t("lbl_org_rejected_subtitle")}
        </div>
      </div>
      <CreateOrganizationForm
        onSubmitted={onResubmit}
        initialValues={{ code, name, logoUrl, websiteUrl, description }}
      />
    </div>
  );
};

export default OrganizationRejected;
